var _rect, _path, _path2, _path3, _path4, _path5, _path6, _path7, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgProfessionalNotificationsrounded(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 80,
    height: 80,
    viewBox: "0 0 80 80",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 80,
    height: 80,
    rx: 40,
    fill: "url(#paint0_linear_4808_12819)"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M30 56.6654V26.6654C30 25.7813 30.3512 24.9335 30.9763 24.3083C31.6014 23.6832 32.4493 23.332 33.3333 23.332H46.6667C47.5507 23.332 48.3986 23.6832 49.0237 24.3083C49.6488 24.9335 50 25.7813 50 26.6654V56.6654H30Z",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M30.0007 40H26.6673C25.7833 40 24.9354 40.3512 24.3103 40.9763C23.6852 41.6014 23.334 42.4493 23.334 43.3333V53.3333C23.334 54.2174 23.6852 55.0652 24.3103 55.6904C24.9354 56.3155 25.7833 56.6667 26.6673 56.6667H30.0007",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M50 35H53.3333C54.2174 35 55.0652 35.3512 55.6904 35.9763C56.3155 36.6014 56.6667 37.4493 56.6667 38.3333V53.3333C56.6667 54.2174 56.3155 55.0652 55.6904 55.6904C55.0652 56.3155 54.2174 56.6667 53.3333 56.6667H50",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M36.666 30H43.3327",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M36.666 36.668H43.3327",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M36.666 43.332H43.3327",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M36.666 50H43.3327",
    stroke: "white",
    strokeWidth: 3.33333,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_4808_12819",
    x1: 40,
    y1: 0,
    x2: 40,
    y2: 80,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#54B27C"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#186639"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgProfessionalNotificationsrounded);
export default __webpack_public_path__ + "static/media/Professional Notifications rounded.2e64c98d08b9adcb3e73c6914dedb6a2.svg";
export { ForwardRef as ReactComponent };